import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SolutionsHeader from "../common/solutions/SolutionsHeader";
import SolutionsFooter from "../common/solutions/SolutionsFooter";
import "preline/preline";
import NewsLetter from "../pages/solutions/NewsLetter";
import { TracingBeam } from "../ui/tracing-beam";
import { motion } from "framer-motion";

const SolutionsLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0.0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.3,
        duration: 0.8,
        ease: "easeInOut",
      }}
    >
      <SolutionsHeader />
      {/* <TracingBeam className="px-"> */}
      <Outlet />
      {/* </TracingBeam> */}
      <NewsLetter />
      <SolutionsFooter />
      {/* mobile bottom navigation */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[rgb(14,15,17)] border-t border-gray-700 lg:hidden flex justify-around items-center h-[3.75rem]">
        <button
          className={`flex flex-col items-center text-xs text-white-700 focus:outline-none ${
            pathname === "/solutions" ? "text-gold" : ""
          }`}
          onClick={() => navigate("/solutions")}
        >
          {/* <svg
            className="w-6 h-6 mb-1"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 icon icon-tabler icons-tabler-filled icon-tabler-home"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12.707 2.293l9 9c.63 .63 .184 1.707 -.707 1.707h-1v6a3 3 0 0 1 -3 3h-1v-7a3 3 0 0 0 -2.824 -2.995l-.176 -.005h-2a3 3 0 0 0 -3 3v7h-1a3 3 0 0 1 -3 -3v-6h-1c-.89 0 -1.337 -1.077 -.707 -1.707l9 -9a1 1 0 0 1 1.414 0m.293 11.707a1 1 0 0 1 1 1v7h-4v-7a1 1 0 0 1 .883 -.993l.117 -.007z" />
          </svg>
          Home
        </button>
        <button
          className="flex flex-col items-center text-xs text-white-700 focus:outline-none"
          onClick={() => navigate("/realty")}
        >
          <img
            src="/images/realty/realty-logo.png"
            alt="Realty"
            className="w-7 h-7 object-cover"
          />
          Realty
        </button>
        <button
          className="flex flex-col items-center text-xs text-white-700 focus:outline-none"
          onClick={() => navigate("/")}
        >
          {/* If the image is in the public folder, use the following: */}
          {/* <img
            width={24}
            height={24}
            src={realtyLogo}
            className="w-6 h-6 object-cover"
            alt="Realty Logo"
          /> */}
          {/* If the image is in the src/assets folder, use import: */}
          <img
            src="/images/color-logo-white.png"
            alt="Holdings"
            className="w-8 h-8 object-cover"
          />
          Holdings
        </button>
      </div>
      {/* preline */}
      <PageHandler />
    </motion.div>
  );
};

const PageHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Ensure Preline's autoInit method is called after every route change
    if (window.HSStaticMethods?.autoInit) {
      window.HSStaticMethods.autoInit();
    } else {
      console.warn("HSStaticMethods.autoInit is not defined.");
    }
  }, [location.pathname]); // Trigger effect on pathname change

  return null; // This component exists purely for handling side effects
};

export default SolutionsLayout;
